import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { getOnboardingStateGQL } from '@confluence/onboarding-helpers/entry-points/getOnboardingStateGQL.ts';
import {
	NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS,
	ONBOARDING_EXPERIENCES,
} from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

export const preloadNthUserHomeOnboardingRevampState = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [
				ONBOARDING_EXPERIENCES.IS_FOUNDING_ADMIN,
				...Object.values(NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS),
			],
		},
	});
};
